import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleCrossed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-crossed, comment, feedback"><path d="M14.1213 8.85314L12 10.9745M12 10.9745L9.87868 13.0958M12 10.9745L9.87868 8.85314M12 10.9745L14.1213 13.0958M3.75 3.75H20.25V18.25H15.0155L11.9979 20.75L9.0155 18.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBubbleCrossed;
